import { render, staticRenderFns } from "./ApplicantList.vue?vue&type=template&id=73378f4c"
import script from "../../controllers/applicant/applicant-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/applicant/applicant-list.js?vue&type=script&lang=js&external"
import style0 from "./ApplicantList.vue?vue&type=style&index=0&id=73378f4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports